import { IProductState } from '@/store/types';

const state: IProductState = {
  products: {},
  otherProducts: {},
};

export default state;